import * as React from "react";
import LogOverview from "../../DAMS/Tabs/LogOverview";

/**
 * This is the Logs tab in the DOOP module. It is a wrapper around the KafkaEventsPage from the DOOP module.
 */

const Logs: React.FC = () => {
    return (
        // <KafkaEventsPage parentModule={new KafkaModule(null)} />
        <LogOverview/>
    )
}

export default Logs;